import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatTranslations } from '../../../services/chat-translation.service';
import { ChatFeedback } from '../../../services/wings-assistant-chat.service';

@Component({
  selector: 'wings-feedback-modal',
  standalone: false,
  templateUrl: './wings-feedback-modal.component.html',
  styleUrls: ['./wings-feedback-modal.component.scss']
})
export class WingsFeedbackModalComponent {
  @Input() visible: boolean = false;
  @Input() translations: ChatTranslations;
  @Input() isSendingFeedback: boolean = false;
  @Input() initialRating: number = 0;
  @Input() initialComment: string = '';
  
  @Output() close = new EventEmitter<Event>();
  @Output() submit = new EventEmitter<ChatFeedback>();
  @Output() ratingChanged = new EventEmitter<number>();
  
  public feedbackRating: number = 0;
  public feedbackComment: string = '';
  
  ngOnChanges() {
    if (this.visible) {
      this.feedbackRating = this.initialRating;
      this.feedbackComment = this.initialComment;
    }
  }
  
  public closeModal(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.close.emit(event);
  }
  
  public setFeedbackRating(rating: number): void {
    this.feedbackRating = rating;
    this.ratingChanged.emit(rating);
  }
  
  public submitFeedback(): void {
    this.submit.emit({
      rating: this.feedbackRating,
      comment: this.feedbackComment.trim() || undefined,
      timestamp: new Date(),
      messageIndex: 0 // Este valor será substituído pelo componente principal
    });
  }
}
